import { useNavigate } from '@tanstack/router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useBoundStore } from '../../store/store'
import Icon from '../icon'

const TopAd = () => {
  const { t } = useTranslation('topAd')
  const isTopAdVisible = useBoundStore(state => state.common.isTopAdVisible)
  const setIsTopAdVisible = useBoundStore(
    state => state.common.setIsTopAdVisible,
  )
  const username = useBoundStore(state => state.user.username)
  const navigate = useNavigate()

  useEffect(() => {
    if (username) {
      setIsTopAdVisible(false)
    } else {
      setIsTopAdVisible(true)
    }
  }, [username])

  if (!isTopAdVisible) return null

  return (
    <div className="flx-ctr sticky w-screen h-[38px] bg-[#df0033] z-[100] left-0 top-0">
      <Icon id="gift" width="21" height="19" color="#fff" />
      <p className="font-Geometr706-BlkCn-BT text-xl text-white uppercase ml-[13px] mr-4 my-0">
        {t('register-today')}
      </p>
      <button onClick={() => navigate({ to: '/register' })}>
        <span className="text-[10px] font-Syncopate-Bold text-[#df0033] uppercase bg-white px-[21px] py-2 rounded-sm hover:opacity-80">
          {t('receive-bonus')}
        </span>
      </button>
      <button
        className="absolute -translate-y-2/4 flex right-[22px] top-2/4 hover:opacity-80"
        onClick={() => setIsTopAdVisible(false)}
        aria-label="Close top ad">
        <Icon id="outline-close-circle-2" width="18" height="18" color="#fff" />
      </button>
    </div>
  )
}

export default TopAd
